<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.editCoupon") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #405950">
        <i
          :class="$i18n.locale === 'en' ? 'fas fa-forward' : 'fas fa-backward'"
        ></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.coupon_name')"
            v-model.trim="data.nameAr"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.coupon_nameEN')"
            v-model.trim="data.nameEn"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.code')"
            v-model.trim="data.code"
            required
          />
          <base-input
            col="6"
            type="number"
            step="any"
            min="1"
            max="100"
            :placeholder="$t('PLACEHOLDERS.discountPercentage')"
            v-model.trim="data.discount_percentage"
            required
          />

          <div class="input_wrapper switch_wrapper my-3 col-6">
            <v-switch
              color="green"
              :label="$t('PLACEHOLDERS.allowed_for_festivals')"
              v-model="data.allowed_for_festivals"
              hide-details
            ></v-switch>
          </div>
          <div class="input_wrapper switch_wrapper my-3 col-6">
            <v-switch
              color="green"
              :label="$t('PLACEHOLDERS.allowed_for_orders')"
              v-model="data.allowed_for_orders"
              hide-details
            ></v-switch>
          </div>

          <div class="input_wrapper switch_wrapper my-3 col-6">
            <v-switch
              color="green"
              :label="$t('PLACEHOLDERS.has_maximum_amount')"
              v-model="data.has_maximum_amount"
              hide-details
            ></v-switch>
          </div>
          <base-input
            v-if="data.has_maximum_amount"
            col="6"
            type="number"
            step="any"
            min="0.01"
            :placeholder="$t('PLACEHOLDERS.maximum_amount')"
            v-model.trim="data.maximum_amount"
            required
          />

          <div class="input_wrapper switch_wrapper my-3 col-6">
            <v-switch
              color="green"
              :label="$t('PLACEHOLDERS.has_limited_usage')"
              v-model="data.has_limited_usage"
              hide-details
            ></v-switch>
          </div>
          <base-input
            v-if="data.has_limited_usage"
            col="6"
            type="number"
            min="1"
            :placeholder="$t('PLACEHOLDERS.usage_limit')"
            v-model.trim="data.usage_limit"
            required
          />

          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.count_uses_coupon')"
            :value="data.usage_count"
            disabled
          />

          <div class="input_wrapper switch_wrapper my-3 col-6">
            <v-switch
              color="green"
              :label="
                data.allowed_for_all
                  ? $t('PLACEHOLDERS.chooseAll')
                  : $t('PLACEHOLDERS.choose')
              "
              v-model="data.allowed_for_all"
              hide-details
            ></v-switch>
          </div>

          <base-select-input
            v-if="!data.allowed_for_all"
            multiple
            col="6"
            :optionsList="allClients"
            :placeholder="$t('PLACEHOLDERS.allowed_clients')"
            v-model="data.allowed_clients"
            required
          />

          <div class="input_wrapper switch_wrapper my-5 col-6">
            <v-switch
              color="green"
              :label="
                data.is_active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.is_active"
              hide-details
            ></v-switch>
          </div>

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditCoupon",

  data() {
    return {
      isWaitingRequest: false,
      allClients: [],
      data: {
        nameAr: null,
        nameEn: null,
        code: null,
        discount_percentage: null,
        allowed_for_festivals: true,
        allowed_for_orders: true,
        has_maximum_amount: false,
        maximum_amount: null,
        has_limited_usage: false,
        usage_limit: null,
        usage_count: 0,
        allowed_for_all: true,
        allowed_clients: [],
        is_active: true,
      },
    };
  },

  methods: {
    async getAllClients() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: "clients?is_active=1&page=0&limit=0",
        });
        const clients = res.data.data?.data || res.data.data || [];
        this.allClients = (Array.isArray(clients) ? clients : []).map(
          (client) => ({
            id: client.user?.id || client.id,
            name:
              client.user?.name ||
              client.name ||
              client.mobile ||
              String(client.user?.id || client.id),
          })
        );
      } catch (error) {
        console.log(error.response?.data?.message);
      }
    },

    async showCoupon() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: `coupons/${this.$route.params.id}`,
        });
        const coupon = res.data.data.Coupon || res.data.data;
        this.data.nameAr = coupon.name_ar;
        this.data.nameEn = coupon.name_en;
        this.data.code = coupon.code;
        this.data.discount_percentage = coupon.discount_percentage;
        this.data.allowed_for_festivals = !!coupon.allowed_for_festivals;
        this.data.allowed_for_orders = !!coupon.allowed_for_orders;
        this.data.has_maximum_amount = !!coupon.has_maximum_amount;
        this.data.maximum_amount = coupon.maximum_amount;
        this.data.has_limited_usage = !!coupon.has_limited_usage;
        this.data.usage_limit = coupon.usage_limit;
        this.data.usage_count = coupon.usage_count ?? 0;
        this.data.allowed_for_all = !!coupon.allowed_for_all;
        this.data.is_active = !!coupon.is_active;
        this.data.allowed_clients = (coupon.allowed_clients || []).map(
          (client) => ({
            id: client.id,
            name: client.name || client.mobile || String(client.id),
          })
        );
      } catch (error) {
        console.log(error.response?.data?.message);
      }
    },

    validateFormInputs() {
      const percentage = Number(this.data.discount_percentage);
      if (!percentage || percentage < 1 || percentage > 100) {
        this.$message.error(this.$t("MESSAGES.couponDiscountPercentageInvalid"));
        return;
      }

      if (!this.data.allowed_for_festivals && !this.data.allowed_for_orders) {
        this.$message.error(this.$t("MESSAGES.couponAllowedScopeRequired"));
        return;
      }

      if (this.data.has_maximum_amount) {
        const maxAmount = Number(this.data.maximum_amount);
        if (!maxAmount || maxAmount < 0.01) {
          this.$message.error(this.$t("MESSAGES.couponMaximumAmountRequired"));
          return;
        }
      }

      if (this.data.has_limited_usage) {
        const usageLimit = Number(this.data.usage_limit);
        if (!usageLimit || usageLimit < 1) {
          this.$message.error(this.$t("MESSAGES.couponUsageLimitRequired"));
          return;
        }
      }

      if (
        !this.data.allowed_for_all &&
        (!this.data.allowed_clients || this.data.allowed_clients.length < 1)
      ) {
        this.$message.error(this.$t("MESSAGES.couponClientsRequired"));
        return;
      }

      this.isWaitingRequest = true;
      this.submitForm();
    },

    async submitForm() {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("_method", "PUT");
      REQUEST_DATA.append("name[ar]", this.data.nameAr ?? "");
      REQUEST_DATA.append("name[en]", this.data.nameEn ?? "");
      REQUEST_DATA.append("code", this.data.code ?? "");
      REQUEST_DATA.append(
        "discount_percentage",
        this.data.discount_percentage ?? ""
      );
      REQUEST_DATA.append(
        "allowed_for_festivals",
        this.data.allowed_for_festivals ? 1 : 0
      );
      REQUEST_DATA.append(
        "allowed_for_orders",
        this.data.allowed_for_orders ? 1 : 0
      );
      REQUEST_DATA.append(
        "has_maximum_amount",
        this.data.has_maximum_amount ? 1 : 0
      );
      if (this.data.has_maximum_amount) {
        REQUEST_DATA.append("maximum_amount", this.data.maximum_amount);
      }
      REQUEST_DATA.append(
        "has_limited_usage",
        this.data.has_limited_usage ? 1 : 0
      );
      if (this.data.has_limited_usage) {
        REQUEST_DATA.append("usage_limit", this.data.usage_limit);
      }
      REQUEST_DATA.append(
        "allowed_for_all",
        this.data.allowed_for_all ? 1 : 0
      );
      if (!this.data.allowed_for_all) {
        (this.data.allowed_clients || []).forEach((client, index) => {
          REQUEST_DATA.append(`allowed_clients[${index}]`, client.id);
        });
      }
      REQUEST_DATA.append("is_active", this.data.is_active ? 1 : 0);

      try {
        await this.$axios({
          method: "POST",
          url: `coupons/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/coupons/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(
          error.response?.data?.message || this.$t("MESSAGES.errorOccurred")
        );
      }
    },
  },

  created() {
    this.getAllClients();
    this.showCoupon();
  },
};
</script>
